import { Modal } from 'shared/ui/modal';
import { useModal } from 'shared/lib/modal';
import { FC } from 'react';
import { CardProps } from '../types';
import { Card } from './card';
import { CardContainer } from '../styles';
import { CloseIconButton } from 'shared/ui/buttons/iconButtons/closeButton';

export const ModalCard: FC<CardProps> = props => {
	const { closeModal } = useModal();
	const { onClose, styles, canClose = true, id } = props;
	const handleClose = () => {
		if (canClose) {
			closeModal();
		}
		onClose && onClose();
	};

	return (
		<Modal onClose={handleClose} id={id} zIndex={props.zIndex} scrollable={props.scrollable?.toString()}>
			<CardContainer $width={styles?.width} $height={styles?.height} $maxWidth={styles?.maxWidth}>
				<Card
					{...props}
					buttons={[<CloseIconButton onClick={handleClose} key={0} />]}
				/>
			</CardContainer>
		</Modal>
	);
};
